<div class="main px-3 py-3">
  <div class="bg-grey">
  </div>
  <div class="page-header">
    <div class="title-container">新商品登録</div>
  </div>
  <mat-tab-group class="mat-tab-fill-height" animationDuration="0ms">
    <mat-tab label="参照/ダウンロード" class="label">
      <!-- 参照/ダウンロード -->
      <div class="looker-field">
        <div class="looker-embed">
          <div class="looker-embed">
            <app-tableau-embed [url]="tableauUrl" elementId="T-register-new-goods"></app-tableau-embed>
          </div>
        </div>
        <div class="download-button-field mt-3">
          <div class="spinner" *ngIf="downloading">
            <mat-spinner [diameter]="35"></mat-spinner>
          </div>
          <!-- ボタン本体 -->
          <button [disabled]="downloading" mat-raised-button color="primary" (click)="clickedDownLoad()">
            <i class="fa fa-download"></i>
            ダウンロード
          </button>
        </div>
      </div>
    </mat-tab>
    <mat-tab label="アップロード" class="label">
      <!-- アップロード -->
      <div class="upload-field">
        <div class="message-title">メッセージ</div>
        <div class="upload-control-filed">
          <app-message-field class="message-field"></app-message-field>
          <app-upload-file class="file-drop-field" (fileEvent)="setFile($event)"></app-upload-file>
        </div>
        <div class="upload-button">
          <button mat-raised-button (click)="uploadFile()">
            <i class="fa fa-upload"> アップロード</i>
          </button>
        </div>
        <!-- 非表示ダウンロードリンク -->
        <a #downloadLinkRef style="display: none">非表示リンク</a>
      </div>
    </mat-tab>
  </mat-tab-group>
</div>
